
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { GameDataHandler } from "../game/GameDataHandler";
/* END-USER-IMPORTS */

export default class ScoreTracker extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 128.49999767975055, y ?? 55);

    // panel
    const panel = scene.add.image(0, 0, "game", "box-top.png");
    panel.scaleY = 0.833;
    this.add(panel);

    // score
    const score = scene.add.text(-38, -1, "", {});
    score.setOrigin(0.5, 0.5);
    score.text = "0";
    score.setStyle({ "align": "center", "baselineY":1.2,"color": "#20e4e2", "fixedWidth":120,"fixedHeight":65,"fontFamily": "HouseMovements", "fontSize": "60px" });
    score.setPadding({"top":2});
    this.add(score);

    // iconMoney
    const iconMoney = scene.add.image(57, 7, "game", "score-cash.png");
    this.add(iconMoney);

    this.score = score;

    /* START-USER-CTR-CODE */
    this.on(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.registry.events.off(GameDataHandler.events.ChangeScore, this.onScoreChange, this);
    });

    this.scene.registry.events.on(GameDataHandler.events.ChangeScore, this.onScoreChange, this);
    /* END-USER-CTR-CODE */
  }

  private score: Phaser.GameObjects.Text;

  /* START-USER-CODE */

  protected onScoreChange(parent: any, value: any, previousValue: any) {
    this.score.text = Math.trunc(value).toString();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
